import type { SceneShadeZone } from '../scene/scene-format';

// Shade ground — where the plate is already in shadow, so a figure standing there
// sinks into it and stops casting its own. The sibling of reflective-ground: the
// same ground-rectangle-with-feather shape, queried per actor per frame, but it
// returns a 0..1 SHADE factor rather than a reflection strength.
//
// This is the other half of "the chiaroscuro includes the player": the shadow
// baked into the photograph becomes a fact a moving character obeys.

/** How deep in shadow the ground is under an actor at (x, z), 0..1. Zones overlap
 *  freely; the strongest wins. Feathered at the edges so a figure dissolves into
 *  the shade rather than snapping dark at a boundary. */
export function shadeAt(zones: readonly SceneShadeZone[], x: number, z: number): number {
  let shade = 0;
  for (const zone of zones) {
    const s = zone.strength * inset(zone, x, z);
    if (s > shade) shade = s;
  }
  return shade;
}

/** 1 across the zone's core, smoothly to 0 across `feather` at every edge. */
function inset(zone: SceneShadeZone, x: number, z: number): number {
  const inX = Math.min(x - zone.x0, zone.x1 - x);
  const inZ = Math.min(z - zone.z0, zone.z1 - z);
  const inside = Math.min(inX, inZ);
  if (inside <= 0) return 0;
  return zone.feather > 0 ? smoothstep(Math.min(1, inside / zone.feather)) : 1;
}

const smoothstep = (t: number) => t * t * (3 - 2 * t);
